/**
 * Whether a URL is one this app has a screen for.
 *
 * There is no router; `App.vue` reads the URL once and picks a phase. Anything
 * whose first segment is not listed here renders the 404 screen instead of
 * silently showing the home screen under a wrong address.
 */
// `shop` is where the payment gateway sends the browser back to; `account` is the restart e-mail's `/account/confirm`.
const KNOWN_TOP_SEGMENTS = new Set(['admin-panel', 'verify-email', 'reset-password', 'shop', 'account']);

export function isKnownPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return true;
  if (import.meta.env.DEV && (path === '/dev/sea' || path === '/dev/harbour')) return true;
  const first = path.split('/')[1] ?? '';
  return KNOWN_TOP_SEGMENTS.has(first);
}

export function readIsNotFound(): boolean {
  if (typeof window === 'undefined') return false;
  return !isKnownPath(window.location.pathname);
}
